/**
 * @Author: 仙道
 * @Date: 2022-12-11 18:27:20
 * @LastEditTime: 2022-12-12 00:00:40
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/store/modules/reportTab.js
 **/
// import Vue from 'vue'
const reportTab = {
  state: {
    tabList: [
      //   {
      //   code: 'A02A01A07',
      //   name: '运营台账',
      //   view: 'http://123.56.162.129:18080/RDP-SERVER/rdppage/main/12274a5e6705fd3d3a82db4e699cf9d1?readonly=0&tenantid=2',
      //   component: ''
      // }, {
      //   code: 'A02A01A08',
      //   name: '污泥处理系统运行记录',
      //   view: '/monitor/alert/IotAlertList.vue',
      //   component: ''
      // }
    ],
    activeCode: ''
  },
  mutations: {
    ADD_TAB_LIST: (state, tabs) => {
      state.tabList = tabs
      // Vue.ls.set('enhance_' + record['code'], arr)
    },
    UPDATE_ACTIVE_TAB_CODE: (state, code) => {
      state.activeCode = code
      // Vue.ls.set('enhance_' + record['code'], arr)
    }
  },
  actions: {
    addReportTab ({ commit, state }, tabs) {
      // const tabList = state.tabList.reduce((arr, cur) => {
      //   const _cur = {
      //     propsData: {},
      //     deviceId: this.deviceId,
      //     tab: cur.name,
      //     key: cur.view,
      //     views: (resolve) => require([`@/views/${cur.path}.vue`], resolve)
      //   }
      // }, [])
      const tabFindByCode = state.tabList.find(item => item.code == tabs.code)
      if (tabFindByCode) {
        commit('UPDATE_ACTIVE_TAB_CODE', tabFindByCode.code)
        return
      }

      const tabList = state.tabList
      const isIframeComponent = tabs.cusProp1.indexOf('http') > -1
      const component = (resolve) => require([isIframeComponent ? `@/components/layouts/iframeReportView.vue` : `@/views/${tabs.cusProp1}`], resolve)
      tabList.push({
        name: tabs.name,
        view: tabs.cusProp1,
        code: tabs.code,
        isIframe: isIframeComponent,
        component: component
      })

      commit('ADD_TAB_LIST', tabList)
      commit('UPDATE_ACTIVE_TAB_CODE', tabs.code)

      // commit('ADD_TAB_LIST', tabs)
    }
  }
}
export default reportTab